import { FC } from 'react';
import clsx from 'clsx';
import styles from './switch.module.css';
import { ISwitchComponent } from '../../../types';

const Switch: FC<ISwitchComponent> = (props) => {

  const {
    label,
    defaultChecked = false,
    onChange,
    disabled = false,
  } = props;

  const disabledClass = disabled ? styles.switchDisabled : '';

  return (
    <label className={clsx(styles.switch, disabledClass)}>
      <input
        type="checkbox"
        defaultChecked={defaultChecked}
        onChange={onChange}
        disabled={disabled}
      />
      <span className={styles.switchControl} />
      <span className={styles.switchLabel}>{label}</span>
    </label>
  );

};

export default Switch;
